var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6903",
    "data-name": "Rectangle 6903",
    width: 28,
    height: 28,
    transform: "translate(180 155)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device_node",
    transform: "translate(-180 -155)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iot",
    transform: "translate(80.857 121.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28506",
    "data-name": "Path 28506",
    d: "M124.092,51.285V51a3.681,3.681,0,0,0,2.051-3.356,4.035,4.035,0,0,0-1.868-3.443,5.241,5.241,0,0,0-6.107-4.988,6.665,6.665,0,0,0-12.737.823,5.147,5.147,0,0,0-5.288,5.168,5.576,5.576,0,0,0,.228,1.622.456.456,0,1,0,.866-.287,4.756,4.756,0,0,1-.18-1.335,4.227,4.227,0,0,1,4.7-4.22.456.456,0,0,0,.5-.376,5.756,5.756,0,0,1,11.188-.722.456.456,0,0,0,.547.308,4.329,4.329,0,0,1,5.38,4.213.524.524,0,0,0,.228.456,3.121,3.121,0,0,1,1.636,2.782,2.607,2.607,0,0,1-2.506,2.734h-6a.456.456,0,1,0,0,.911h7.367Z",
    fill: "#00d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28507",
    "data-name": "Path 28507",
    d: "M120.038,232.057a.456.456,0,1,0,0-.911h-1.367v-1.367a.456.456,0,0,0-.456-.456h-1.367v-1.367a.456.456,0,1,0-.911,0v1.367H113.2v-1.367a.456.456,0,1,0-.911,0v1.367h-2.734v-1.367a.456.456,0,1,0-.911,0v1.367h-1.367a.456.456,0,0,0-.456.456v1.367h-1.367a.456.456,0,1,0,0,.911h1.367v2.734h-1.367a.456.456,0,0,0,0,.911h1.367v2.734h-1.367a.456.456,0,1,0,0,.911h1.367v1.367a.456.456,0,0,0,.456.456h1.367v1.367a.456.456,0,1,0,.911,0v-1.367h2.734v1.367a.456.456,0,1,0,.911,0v-1.367h2.734v1.367a.456.456,0,1,0,.911,0v-1.367h1.367a.456.456,0,0,0,.456-.456v-1.367h1.367a.456.456,0,1,0,0-.911h-1.367V235.7h1.367a.456.456,0,0,0,0-.911h-1.367v-2.734Zm-2.279,8.2H107.734V230.234H117.76Z",
    transform: "translate(-4.605 -182.595)",
    fill: "#1c006a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28508",
    "data-name": "Path 28508",
    d: "M124.092,54.99v-3.7h-5.469v5.528a1.823,1.823,0,1,0,.911,0V51.285h3.646v3.7a1.823,1.823,0,1,0,.911,0Zm-4.1,3.586a.911.911,0,1,1-.267-.645A.912.912,0,0,1,119.99,58.576Zm3.646-.911a.911.911,0,1,1,.645-.267A.912.912,0,0,1,123.636,57.665Z",
    fill: "#00d3ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceNode);
export default __webpack_public_path__ + "static/media/device_node.0f7d8633240216273962f142037f8c64.svg";
export { ForwardRef as ReactComponent };